import {css, html, LitElement} from 'lit';
import {customElement, property} from 'lit/decorators';
import {
  containerStyles,
  moduleSpacingStyles,
  normalizeStyles,
  typographyStyles
} from '@webs/components-library/theming';
import {ifDefined} from 'lit/directives/if-defined.js';

@customElement('webs-content-usp')
export class ContentUsp extends LitElement {
  static styles = [
    normalizeStyles,
    moduleSpacingStyles,
    typographyStyles,
    containerStyles,
    css`
    .m-content-usp ::slotted([slot="title"]) {
      max-width: 24.5rem !important;
      margin-bottom: 0.7rem !important;
    }

    .m-content-usp p {
      margin-bottom: 3rem;
    }

    .container--light ::slotted([slot="title"]) { color: var(--color-white) !important; }
    .m-content-usp .light {
      color: var(--color-white);
    }
    `
  ]
  @property()
  id: string;

  @property({attribute: 'space-top'})
  spaceTop = 'm';

  @property({attribute: 'space-bottom'})
  spaceBottom = 'm';

  @property({attribute: 'short-description'})
  shortDescription: string;

  @property({attribute: 'text-style'})
  textStyle: string;

  protected render(): unknown {
    return html`
      <section id="${ifDefined(this.id)}"
               class="m-content-usp ${this.spaceTop ? 'module_top-padding-' + this.spaceTop : ''} ${this.spaceBottom ? 'module_bottom-padding-' + this.spaceBottom : ''}">
        <div part="container" class="container ${this.textStyle == 'light' ? 'container--light' : ''}">
          <slot name="title"></slot>
          ${this.shortDescription ? html`<p class="${this.textStyle == 'light' ? 'light' : ''}">
            ${this.shortDescription}</p>` : ''}
          <webs-grid-row>
            <slot name="cards"></slot>
          </webs-grid-row>
        </div>
      </section>`
  }
}
